import { call, take, put }                    from 'redux-saga/effects';
import axios                                  from 'axios';
import { 
         SET_USER_ACTIVITY, 
         UPDATE_ACTIVITY,
         RECORD_ERROR_SAGA,
       }                                      from '../actions';

const userActivityEndpoint = 'https://www.yisumatica.org.il/yisumaticaApi/getUserActivity.php';
 
const mockData = [{
  id:        18393,
  lesson_id: "Circle_circumference",
  liked:     1,
  selected:  1,
  user_name: "localhost@gmail.com",
  viewed:    1
}]
 
function* getUserActivity(): Generator<any,any,any> {
  while(true) {
    try {

    //  console.log('getUserActivity    ')


        const input = yield take('GET_USER_ACTIVITY_SAGA');
        // eslint-disable-next-line no-console
        console.log('[getUserActivity] saga triggered with payload:', input.payload);
        
        const { userEmail } = input.payload;

        if (process.env.NODE_ENV === 'development') {

            yield put(SET_USER_ACTIVITY( mockData ))
            yield put(UPDATE_ACTIVITY())

            console.log('GET_USER_ACTIVITY_SAGA')
            
        }
        if (process.env.NODE_ENV !== 'development' && userEmail !== 'guest@yisumatica.org.il') {

            // get user activity from DB

            // eslint-disable-next-line no-console
            console.log('[getUserActivity] fetching activity for:', userEmail);

            const userActivity = yield call( axios.post, userActivityEndpoint, { user_name: userEmail }); 
            
            if (userActivity) {
              // eslint-disable-next-line no-console
              console.log('[getUserActivity] raw response:', userActivity.data);
            } else {
              // eslint-disable-next-line no-console
              console.log('[getUserActivity] no response object returned');
            }


            if (userActivity && userActivity.data && userActivity.data.result ) {

                yield put(SET_USER_ACTIVITY( userActivity.data.result ))
                yield put(UPDATE_ACTIVITY())
                // eslint-disable-next-line no-console
                console.log('[getUserActivity] activity items loaded:', userActivity.data.result.length);

            }

            else {
              yield put(UPDATE_ACTIVITY())
              // eslint-disable-next-line no-console
              console.log("[getUserActivity] can't get user activity – missing data.result");
            }
            
        } else if (userEmail === 'guest@yisumatica.org.il') {
            // eslint-disable-next-line no-console
            console.log('[getUserActivity] skip fetch for guest user');
        }
       

    }
    catch(err) {
      yield put(UPDATE_ACTIVITY())
      yield put(RECORD_ERROR_SAGA({ data: { error: err }, endpoint: 'GET_USER_ACTIVITY_SAGA' }))
      // eslint-disable-next-line no-console
      console.log('[getUserActivity] err  :  '+err);
    }
    finally {}
  }
}


export default getUserActivity;






